export default {"src":"https://images-cdn-staging.curipod.com/d-bb6d0ddd/_next/static/media/feide-logo.aab537d8.ico","height":48,"width":48};